import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './app/App';
import { signOutWhenSessionEnds } from './lib/session';
// Self-hosted font (no requests to Google; Polish characters included). Source Sans 3: large x-height,
// modest capitals – easier to read than the previous Garamond pair.
import '@fontsource-variable/source-sans-3/wght.css';
import './styles/app.css';

const onError = (error: unknown) => sessionEnded(error);
const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});
const sessionEnded = signOutWhenSessionEnds(queryClient);

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element');
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
